{
  "name": "primus-web",
  "version": "10.2.31",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --proxy-config proxy.conf.dev.json",
    "start-local": "ng serve --proxy-config proxy.conf.local.json",
    "start-local-prod": "npm run build-prod && npx http-server -p 4200 -c-1 -P http://localhost:5000 ./dist/browser",
    "start-local-unsecure": "ng serve --host 0.0.0.0 --proxy-config proxy.conf.local.json",
    "build": "ng build",
    "build-prod": "node --max_old_space_size=8048 ./node_modules/@angular/cli/bin/ng build --configuration production",
    "build-sw": "./node_modules/.bin/ngsw-config ./dist ./ngsw-config.json",
    "test": "jest",
    "test:watch": "jest --watch",
    "test:coverage": "jest --coverage",
    "test:mutation": "stryker run",
    "test-web-runner": "web-test-runner test/**/*.test.js --node-resolve",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org kulturit --project primus ./dist && sentry-cli sourcemaps upload --org kulturit --project primus ./dist"
  },
  "browser": {
    "fs": false,
    "os": false,
    "path": false
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.1.5",
    "@angular/cdk": "^21.1.5",
    "@angular/common": "^21.1.5",
    "@angular/compiler": "^21.1.5",
    "@angular/core": "^21.1.5",
    "@angular/forms": "^21.1.5",
    "@angular/localize": "^21.1.5",
    "@angular/material": "^21.1.5",
    "@angular/material-moment-adapter": "^21.1.5",
    "@angular/platform-browser": "^21.1.5",
    "@angular/platform-browser-dynamic": "^21.1.5",
    "@angular/router": "^21.1.5",
    "@angular/service-worker": "^21.1.5",
    "@ekultur/authentication": "^8.0.1",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@plausible-analytics/tracker": "^0.4.4",
    "@sentry/angular": "^10.29.0",
    "@sentry/browser": "^10.29.0",
    "@sentry/cli": "^2.58.2",
    "@web-components/dms": "^1.2.1",
    "angularx-qrcode": "^21.0.4",
    "file-saver": "^2.0.5",
    "jest": "^30.2.0",
    "jest-preset-angular": "^16.0.0",
    "jszip": "^3.10.1",
    "moment": "^2.30.1",
    "ng2-dragula": "^6.0.0",
    "ngx-filesaver": "^21.0.0",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "wavesurfer.js": "^7.12.11",
    "zone.js": "~0.16.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.2.0",
    "@angular-eslint/eslint-plugin": "^21.2.0",
    "@angular-eslint/eslint-plugin-template": "^21.2.0",
    "@angular-eslint/schematics": "^21.2.0",
    "@angular-eslint/template-parser": "^21.2.0",
    "@angular/build": "^21.1.4",
    "@angular/cli": "^21.1.4",
    "@angular/compiler-cli": "^21.1.5",
    "@angular/language-service": "^21.1.5",
    "@stryker-mutator/core": "^10.0.0",
    "@stryker-mutator/jest-runner": "^10.0.0",
    "@types/jest": "30.0.0",
    "@typescript-eslint/eslint-plugin": "^8.46.0",
    "@typescript-eslint/parser": "^8.46.0",
    "@web/test-runner": "^0.20.2",
    "eslint": "^9.39.1",
    "jest-environment-jsdom": "^30.4.1",
    "ts-node": "^10.9.2",
    "typescript": "^5.9.3"
  },
  "overrides": {
    "ng2-dragula": {
      "@types/dragula": "^3.7.3",
      "@angular/animations": "21.1.5",
      "@angular/common": "21.1.5",
      "@angular/core": "21.1.5"
    }
  }
}
